import { AssetListOrderKey } from '../domain';
import { useListOrder } from '../../filter/hooks/useListOrder';

export const useAssetListOrder = () => {
  return useListOrder(AssetListOrderKey, 'assetOrderBy', true);
};
